import React from 'react';

interface TimelineResizeHandlesProps {
  startRef: (node: HTMLDivElement | null) => void;
  endRef: (node: HTMLDivElement | null) => void;
  onStartPointerDown: (e: React.PointerEvent<HTMLDivElement>) => void;
  onEndPointerDown: (e: React.PointerEvent<HTMLDivElement>) => void;
}

export function TimelineResizeHandles({
  startRef,
  endRef,
  onStartPointerDown,
  onEndPointerDown
}: TimelineResizeHandlesProps) {
  return (
    <>
      <div
        ref={startRef}
        onPointerDown={onStartPointerDown}
        className="absolute left-0 top-0 z-10 flex h-full w-[6px] cursor-w-resize items-center justify-center"
      >
        <div className="h-4 w-[2px] rounded-full bg-white opacity-0 group-hover:opacity-100" />
      </div>

      <div
        ref={endRef}
        onPointerDown={onEndPointerDown}
        className="absolute right-0 top-0 z-10 flex h-full w-[6px] cursor-e-resize items-center justify-center"
      >
        <div className="h-4 w-[2px] rounded-full bg-white opacity-0 group-hover:opacity-100" />
      </div>
    </>
  );
}
